import { Box, Tab, Tabs } from "@mui/material";
import React from "react";
import Section from "../../../components/section/section";
import AdminListContainer from "../adminList/adminListContainer";
import AdminListProvider from "../adminList/context/adminListContext";
import CoachListContainer from "../coachList/coachListContainer";
import CoachListProvider from "../coachList/context/coachListContext";

type UserManagementTab = "coaches" | "admins";

const UserManagementContainer = (): React.JSX.Element => {
  const [tab, setTab] = React.useState<UserManagementTab>("coaches");

  return (
    <Section>
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
        <Tabs
          value={tab}
          onChange={(_event, value: UserManagementTab) => setTab(value)}
          textColor="primary"
          indicatorColor="primary"
          aria-label="Nutzerverwaltung"
        >
          <Tab
            value="coaches"
            label="Coaches"
            id="user-management-tab-coaches"
            aria-controls="user-management-panel-coaches"
          />
          <Tab
            value="admins"
            label="Admins"
            id="user-management-tab-admins"
            aria-controls="user-management-panel-admins"
          />
        </Tabs>
      </Box>

      {tab === "coaches" && (
        <Box
          role="tabpanel"
          id="user-management-panel-coaches"
          aria-labelledby="user-management-tab-coaches"
        >
          <CoachListProvider>
            <CoachListContainer />
          </CoachListProvider>
        </Box>
      )}

      {tab === "admins" && (
        <Box
          role="tabpanel"
          id="user-management-panel-admins"
          aria-labelledby="user-management-tab-admins"
        >
          <AdminListProvider>
            <AdminListContainer />
          </AdminListProvider>
        </Box>
      )}
    </Section>
  );
};

export default UserManagementContainer;
